import useReveal from "../hooks/useReveal";
import { news } from "../mock";
import { Calendar, ArrowRight } from "lucide-react";

export default function News() {
  useReveal();
  return (
    <section id="uutiset" className="relative py-20 lg:py-28 bg-secondary/40 overflow-hidden">
      {/* Decorative glow orbs */}
      <div className="blob absolute -top-16 right-10 w-72 h-72 bg-primary/10 hidden md:block" />
      <div className="blob blob-slow absolute -bottom-20 -left-16 w-80 h-80 bg-sky-400/10 hidden md:block" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 reveal">
          <div className="max-w-2xl">
            <span className="text-sm font-semibold tracking-[0.18em] uppercase text-primary">
              Uutiset
            </span>
            <h2 className="mt-3 font-extrabold text-3xl sm:text-4xl text-slate-900 leading-tight">
              Ajankohtaista Selektolta
            </h2>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {news.map((n, i) => (
            <article
              key={n.id}
              className="reveal group rounded-2xl bg-white border border-border overflow-hidden hover:shadow-[0_20px_50px_-24px_rgba(20,80,180,0.35)] hover:-translate-y-1 transition-all duration-300"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="h-1.5 bg-gradient-to-r from-primary to-accent" />
              <div className="p-7">
                <div className="flex items-center gap-3 text-xs">
                  <span className="inline-flex items-center gap-1.5 text-slate-500">
                    <Calendar className="w-3.5 h-3.5" />
                    {n.date}
                  </span>
                  <span className="font-semibold uppercase tracking-wider text-primary bg-primary/5 rounded-full px-2.5 py-0.5">
                    {n.category}
                  </span>
                </div>
                <h3 className="mt-4 font-bold text-lg text-slate-900 leading-snug group-hover:text-primary transition-colors">
                  {n.title}
                </h3>
                <p className="mt-3 text-[15px] text-slate-600 leading-relaxed">
                  {n.excerpt}
                </p>
                <div className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-primary">
                  Lue lisää
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
